customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        (
          super(),
          (this.originalButtonText = ""),
          (this.persistentTextActive = !1),
          (this.permanentAddError = !1)
        );
      }
      connectedCallback() {
        setTimeout(() => {
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && (t.disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText = this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText = this.originalButtonText)),
              "true" === this.submitButton.dataset.textOverride && this.submitButtonText)
            ) {
              // Use persistent text when text override is active
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            else if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            ((this.persistentTextActive || "true" === this.submitButton.dataset.textOverride) &&
              this.submitButtonText &&
              this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener("variant:change", this.handleVariantChange.bind(this)));
          }
        }, 100);
      }
      getLiveCart() {
        // Emberly uses the cart drawer on product pages. Never fall back to a
        // cart-page navigation or cart-notification for Add to Cart.
        const liveCart = document.querySelector("cart-drawer");
        if (liveCart) this.cart = liveCart;
        return liveCart;
      }

      async waitForLiveCart() {
        const liveCart = this.getLiveCart();
        if (liveCart) return liveCart;

        // After the last item is deleted, some custom cart flows can temporarily
        // remove the whole <cart-drawer> section. Restore it from Shopify instead
        // of redirecting to /cart or leaving the successful add invisible.
        if (typeof window.ensureEmberlyCartDrawer === "function") {
          const restoredCart = await window.ensureEmberlyCartDrawer();
          if (restoredCart) {
            this.cart = restoredCart;
            return restoredCart;
          }
        }

        // Script-order fallback: give cart-drawer.js a short window to install its
        // recovery helper if product-form.js handled the add first.
        for (let attempt = 0; attempt < 10; attempt += 1) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          const currentCart = this.getLiveCart();
          if (currentCart) return currentCart;
          if (typeof window.ensureEmberlyCartDrawer === "function") {
            const restoredCart = await window.ensureEmberlyCartDrawer();
            if (restoredCart) {
              this.cart = restoredCart;
              return restoredCart;
            }
          }
        }

        return null;
      }

      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            if (showPrice) {
              if (!currentText.startsWith(persistentText)) {
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        this.permanentAddError = !1;
        if (this.submitButton && !this.submitButton.hasAttribute("disabled")) {
          this.submitButton.removeAttribute("aria-disabled");
        }
        const soldOutMessage = this.submitButton?.querySelector(".sold-out-message");
        if (soldOutMessage) soldOutMessage.classList.add("hidden");
        if (this.submitButtonText) this.submitButtonText.classList.remove("hidden");

        this.submitButtonText &&
          setTimeout(() => {
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              if (!showPrice) {
                const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
                t && (this.submitButtonText.textContent = t);
              }
            }
          }, 50);
      }
      ensureSellingPlanValue() {
        let planIdToUse = null;
        try {
          const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            if (sellingPlanInput.value) {
              planIdToUse = sellingPlanInput.value;
            } else {
              const subscribeToggle = document.querySelector('.subscribe-save-wrapper input[type="checkbox"]:checked, .subscribe-save-wrapper-dynamic input[type="checkbox"]:checked');
              if (subscribeToggle) {
                const wrapper = subscribeToggle.closest('.subscribe-save-wrapper, .subscribe-save-wrapper-dynamic');
                if (wrapper) {
                  planIdToUse = wrapper.dataset.sellingPlanId || subscribeToggle.dataset.planId;
                }
                
                if (planIdToUse) {
                  sellingPlanInput.value = planIdToUse;
                  sellingPlanInput.setAttribute('value', planIdToUse);
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ product-form.js: Error setting selling_plan:', error);
        }
        return planIdToUse;
      }
      onSubmitHandler(t) {
        if ((t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled"))) return;

        // Never trust the cart reference captured when the product-form first
        // connected. Empty-cart/AJAX renders can replace cart UI in some themes.
        this.cart = this.getLiveCart();

        // A new add invalidates any older drawer refresh that may still be in
        // flight from a previous add/delete cycle.
        this.cart?.invalidatePendingRefresh?.();

        (this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading__spinner").classList.remove("hidden"));

        const e = fetchConfig("javascript");
        ((e.headers["X-Requested-With"] = "XMLHttpRequest"), delete e.headers["Content-Type"]);
      
        const planIdToUse = this.ensureSellingPlanValue();
        
        const s = new FormData(this.form);
        

        // Check if premium-attachment-kit has already added items[] inputs to the form
        const hasItemsInputs = this.form.querySelector('input[name^="items["]') !== null;

        if (hasItemsInputs) {
          // Premium-attachment-kit has added items[] inputs - use FormData directly

          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s),
            fetch(`${routes.cart_add_url}`, e)
              .then((t) => t.json())
              .then(this.handleCartResponse.bind(this, s, t))
              .catch((t) => {
                console.error(t);
              })
              .finally(this.handleSubmitFinally.bind(this, t)));
        } else {
          // Original behavior: single product with FormData
          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s),
            fetch(`${routes.cart_add_url}`, e)
              .then((t) => t.json())
              .then(this.handleCartResponse.bind(this, s, t))
              .catch((t) => {
                console.error(t);
              })
              .finally(this.handleSubmitFinally.bind(this, t)));
        }
      }
      async handleCartResponse(formData, event, responseData) {
        if (responseData.status) {
          const errorMessage = responseData.description || responseData.message || "Unable to add this item to cart.";
          console.warn("[Emberly cart] Add to cart rejected:", errorMessage, responseData);

          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          });

          this.handleErrorMessage(errorMessage);
          this.error = !0;
          this.permanentAddError = /sold\s*out|unavailable|not\s+available/i.test(String(errorMessage));

          if (this.permanentAddError) {
            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (soldOutMessage && this.submitButtonText) {
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
            }
          }
          return;
        }

        // Re-resolve the live cart AFTER /cart/add succeeds. This is the critical
        // empty-cart -> re-add fix: do not render into an old detached drawer.
        const liveCart = await this.waitForLiveCart();
        if (!liveCart) {
          // The Shopify add has already succeeded. Keep the customer on the PDP,
          // release any stale scroll lock, and expose a precise recovery error.
          document.body.classList.remove("overflow-hidden");
          console.error("[Emberly cart] Cart was added successfully, but the cart drawer could not be restored.");
          return;
        }

        this.cart = liveCart;
        this.permanentAddError = !1;
        this.error = !1;
        
          /* FAST PATH: add response already has the drawer HTML — show it now,
              don't wait for other cart requests (they can stall ~8s) */
          if (responseData.sections && typeof liveCart.renderContents === 'function') {
            try {
              liveCart.renderContents(responseData);
              if (!liveCart.classList.contains('active') && typeof liveCart.open === 'function') {
                liveCart.open(this.submitButton);
              }
            } catch (e) { console.error('[Emberly cart] fast render failed', e); }
            this.handleSubmitFinally(event); // unlock button immediately
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: responseData,
              cartUiSynced: true
            });
            return;
          }


        const paintLatestCart = async () => {
          let synced = false;
          try {
            if (typeof liveCart.syncAfterAdd === "function") {
              synced = await liveCart.syncAfterAdd(responseData);
            } else if (typeof liveCart.renderContents === "function") {
              liveCart.renderContents(responseData);
              synced = true;
            }

            // Successful Add to Cart must always open the currently mounted drawer.
            // This is intentionally repeated even though syncAfterAdd normally opens
            // it, so a custom render path can never leave a successful add hidden.
            const currentDrawer =
              document.querySelector("cart-drawer") ||
              (typeof window.ensureEmberlyCartDrawer === "function"
                ? await window.ensureEmberlyCartDrawer()
                : null);
            if (synced && currentDrawer && typeof currentDrawer.open === "function") {
              currentDrawer.open(this.submitButton || undefined);
            }
          } catch (error) {
            console.error("[Emberly cart] Unable to paint latest cart:", error);
          }

          // Publish only after the visible cart has been reconciled. Publishing
          // first can start competing cart refreshes and recreate the stale UI.
          const marker = CartPerformance.createStartingMarker("add:wait-for-subscribers");
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: responseData,
            cartUiSynced: synced,
          });
          CartPerformance.measureFromMarker("add:wait-for-subscribers", marker);
        };

        const modal = this.closest("quick-add-modal");
        if (modal) {
          document.body.addEventListener(
            "modalClosed",
            () => setTimeout(() => void paintLatestCart()),
            { once: true },
          );
          modal.hide(!0);
        } else {
          await paintLatestCart();
        }
      }
      handleSubmitFinally(event) {
        if (
          (this.submitButton.classList.remove("loading"),
          this.permanentAddError || this.submitButton.removeAttribute("aria-disabled"),
          this.querySelector(".loading__spinner")?.classList.add("hidden"),
          this.error || "true" !== this.submitButton.dataset.textOverride)
        ) {
          if (!this.error && this.persistentTextActive) {
            const showPrice = "true" === this.submitButton.dataset.showPrice;
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t && this.submitButtonText) {
              if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                this.submitButtonText.textContent = t;
              }
            }
          }
        } else;
        CartPerformance.measureFromEvent("add:user-action", event);
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (t) (this.submitButton.setAttribute("disabled", "disabled"), e && (this.submitButtonText.textContent = e));
        else {
          if ((this.submitButton.removeAttribute("disabled"), "true" === this.submitButton.dataset.textOverride));
          else if (this.persistentTextActive) {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t) return void (this.submitButtonText.textContent = t);
          }
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          document.removeEventListener("variant:change", this.handleVariantChange));
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
